<template>
  <el-card class="data">
    <div class="data-title flex-space-between" slot="header">
      <p>YouTube Regular Challenges</p>
      <YouTubeRegularFilter  :challenge_type="challenge_type"/>
      <YouTubeRegularDialog />
    </div>
    <el-table
      :data="challenges.data"
      :default-sort="{ prop: order_column, order: order_type }"
      @sort-change="sort"
      class="w100"
      stripe
    >
      <el-table-column
        label="Username"
        prop="author.name"
        sortable
      ></el-table-column>
      <el-table-column label="Views" prop="track.views" sortable></el-table-column>
      <el-table-column label="Video Link" prop="link" sortable></el-table-column>
      <el-table-column label="Wallet" prop="wallet" sortable></el-table-column>
      <el-table-column label="Create date" prop="created_at" sortable>
        <template slot-scope="props">
          {{ props.row.created_at | date }}
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right" width="200%">
        <template slot-scope="props">
          <el-tooltip v-if="challenges.manual_payment" content="Manual Payment" placement="top">
            <el-button circle size="small" icon="el-icon-money" @click="manualPayment(props.row.id)"></el-button>
          </el-tooltip>
          <el-tooltip v-if="props.row.earlybird || props.row.shoutout"
                      content="Bonus" placement="top">
            <el-popover placement="left" trigger="click" width="350">
              <el-button slot="reference" class="mr10" type="warning" circle size="small"
                         icon="el-icon-edit"></el-button>
              <div style="text-align: center">
                <p class="m0">Select the bonus you want to add for user <b>{{ props.row.username }}</b></p>
                <el-checkbox-group v-model="props.row.bonuses" @change="addBonuses($event, props.row.id)"
                                   class="mt10" size="small">
                  <el-checkbox-button  v-if="props.row.earlybird" label="earlybird"
                                       :disabled="props.row.bonuses.includes('earlybird')">Earlybird</el-checkbox-button>
                  <el-checkbox-button v-if="props.row.shoutout" label="shoutout"
                                      :disabled="props.row.bonuses.includes('shoutout')">Shoutout</el-checkbox-button>
                </el-checkbox-group>
              </div>
            </el-popover>
          </el-tooltip>
            <el-tooltip content="Delete" placement="top">
            <el-button
              type="danger"
              circle
              size="small"
              icon="el-icon-close"
              @click="deleteT(props.row.id)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="Status" placement="top">
            <el-popover placement="left" trigger="click" width="300" @after-leave="isClaimed = false">
              <el-button slot="reference" class="ml10" :type="btnStatus(props.row.status, 'type')"
                         circle size="small" :icon="btnStatus(props.row.status, 'icon')"
                         @click="claimCheck(props.row)"></el-button>
              <div class="video-status">
                <p class="m0">Edit video status for user <b>{{ props.row.username }}</b></p>
                <p style="color: red;" class="m0" v-if="isClaimed">*This video needs to be manually claimed</p>
                <el-radio-group class="mt10" v-model="props.row.status" size="small"
                                @change="changeVideoStatus($event, props.row)">
                  <el-radio-button :label="1">Approve{{ props.row.status === 1 ? 'd' : ''}}</el-radio-button>
                  <el-radio-button :label="0">Pending</el-radio-button>
                  <el-radio-button :label="2">Reject{{ props.row.status === 2 ? 'ed' : ''}}</el-radio-button>
                </el-radio-group>
              </div>
            </el-popover>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="page"
      :page-sizes="[5, 10, 25, 50, 100]"
      :page-size="page_size"
      :page-count="page_count"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </el-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import YouTubeRegularFilter from "./YouTubeRegularFilter";
import YouTubeRegularDialog from "./YouTubeRegularDialog";
import axios from '@/plugins/axios'
import moment from "moment"

export default {
  name: "RegularTable",
  props: {
    challenge_type: {
      type: String
    },
    isClaimed: false
  },
  components: { YouTubeRegularDialog,YouTubeRegularFilter },
  computed: {
    ...mapState('youtubeRegular', [
      'challenges',
      'wallet',
      'page',
      'page_size',
      'total',
      'page_count',
      'order_column',
      'order_type'
    ]),
    challengeList(){
      if (this.shorts) {
        return this.shorts;
      }
      return [];
    }
  },

  methods: {
    ...mapActions('challenges', ['changeStatus', 'updateWallet']),
    ...mapActions('youtubeRegular', ['read', 'delete', 'update']),
    ...mapMutations('youtubeRegular', [
      'setPage',
      'setPageSize',
      'setPageCount',
      'setOrdering',
      'setDialog',
      'setSelectedChallenge',
      'setSelectedTrack',
      'removeLastBonus'
    ]),

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.read()
    },
    currentChange(page) {
      this.setPage(page)
      this.read()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.read()
    },
    deleteT(id) {
      this.$confirm(
        'You will permanently delete this tiktok challenge. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.delete(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete cancelled'
          })
        })
    },
    async addBonuses(value, id) {
      try {
        const confirm = await this.$confirm(
            'Please note that this will permanently add money to this user and his affiliate partner. ' +
            'Do you really want to add this bonus?', 'Bonus'
        )
        if (confirm) this.update({ bonuses: value, id })
      } catch (e) {
        this.removeLastBonus(id)
      }
    },

    async manualPayment(submissionId) {
      try {
        const { value } = await this.$prompt('Manually adding money to the wallet', 'Manual Payment', {
          confirmButtonText: 'Add',
          cancelButtonText: 'Cancel',
        })
        if (+value > 0) {
          await this.$confirm(`Are you sure you want to add $${value}?`, 'Manual Payment', {
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            type: 'warning'
          })
          await this.updateWallet({ id: submissionId, platform: 'youtube', amount: value })
        }
      } catch (err) {
        console.log('ide error')
      }
    },

    async claimCheck(submission) {
      try {
        if (submission.score < 1 && Math.abs(moment(submission.created_at).diff(moment(), 'days')) >= 2) {
          const { data } = await axios.admin.get(`challenges/video/${submission.video_id}/claim`)
          if (data.shouldClaim) this.isClaimed = true
        }
      } catch (err) {
        console.error(err)
      }
    },

    changeVideoStatus(value, row) {
      this.changeStatus({ status: value, platform: 'youtube', id: row.id })
    },
    btnStatus(status, action) {
      return {
        0: {type: 'info', icon: 'el-icon-question'},
        1: {type: 'success', icon: 'el-icon-success'},
        2: {type: 'primary', icon: 'el-icon-error'}
      }[status][action]
    }
  },

  created() {
    //this.read()
  }
}
</script>
